import { isNil, debounce, isEmpty, find, compact } from 'lodash'
import VueScrollTo from 'vue-scrollto'
import TableFileRow from '@/components/adv/TableFileRow'
import DocumentModalPreview from '@/components/utils/DocumentModalPreview'
import Vue from 'vue'
import moment from 'moment'
import { mapGetters } from '../../node_modules/vuex'
// import { bus, EVENTS } from '@/services/bus/index.js'

export default {
  components: {
    TableFileRow,
    DocumentModalPreview
  },
  data () {
    return {
      proceduresMxn: [],
      selectedRow: null,
      showCommentField: true,
      showPreviewModal: false,
      selectedDocument: null,
      displayToolbar: false,
      contratDeReservationDocuments: [],
      notaireDocumentOnglet: [],
      dateConfig: {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Z'
      },
      datetimeConfig: {
        altInput: true,
        altFormat: 'j F Y H:i',
        dateFormat: 'Z',
        time_24hr: true,
        enableTime: true
      },
      availableDocuments: [
        // {value: 'contrat_de_reservation', name: 'Contrat de réservation'},
        {value: 'descriptif_technique', name: 'Descriptif technique'},
        {value: 'plan_du_lot', name: 'Plan du lot'},
        {value: 'plan_du_sous_sol', name: 'Plan du sous-sol'},
        {value: 'plan_de_masse', name: 'Plan de masse'},
        {value: 'plan_d_etage', name: 'Plan d\'étage'},
        {value: 'ernmt', name: 'Ernmt'},
        {value: 'cni', name: 'Carte Nationale d\'Identité'}
      ]
    }
  },
  filters: {
    dateReminder: function (value) {
      let date = moment(value).format('DD/MM')
      let hour = moment(value).format('HH')
      let minute = moment(value).format('mm')

      return date + ' à ' + hour + 'h' + minute
    }
  },
  props: {
    source: {
      type: Object,
      required: false,
      default: () => {}
    },
    lot: {
      type: Object,
      required: false,
      default: () => {}
    },
    program: {
      type: Object,
      required: false,
      default: () => {}
    },
    seller: {
      type: Object,
      required: false,
      default: () => {}
    },
    buyer: {
      type: Object,
      required: false,
      default: () => {}
    },
    coBuyers: {
      type: Array,
      required: false,
      default: () => []
    },
    saving: {
      type: Boolean,
      required: false,
      default: false
    },
    pendingEdition: {
      type: Boolean,
      required: false,
      default: false
    },
    sourceShares: {
      type: Array,
      default: () => []
    },
    sourceNotes: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isSectorManager', 'isSeller', 'currentUserPk', 'isManager', 'isOperator', 'isEditor', 'isPromoteurMode', 'displayRemuneration', 'currentUserCountry']),
    adv () {
      return Object.assign({}, this.source)
    },
    currentComment () {
      return null
    },
    contrat () {
      if (this.adv.contrat_de_reservation && !isEmpty(this.adv.contrat_de_reservation)) {
        return this.adv.contrat_de_reservation
      }
      return null
    },
    financement () {
      return this.adv.financement
    },
    signature () {
      return this.adv.signature
    },
    notaire () {
      if (this.adv && 'notaire' in this.adv && !isEmpty(this.adv.notaire)) {
        return this.adv.notaire
      }
      return null
    },
    venteActee () {
      return this.adv.vente_actee
    },
    livraison () {
      return this.adv.livraison
    },
    advPk () {
      return this.$route.params.id
    },
    address () {
      return this.program.address
    },
    status () {
      return this.adv.status
    },
    isReserved () {
      return this.status === 'reserved'
    },
    isSold () {
      return this.status === 'sold'
    },
    isCanceled () {
      return this.status === 'canceled'
    },
    buyersPk () {
      let tab = [this.buyer.pk]
      tab = tab.concat(this.adv.co_buyers)
      return tab
    },
    buyers () {
      let buyers = []
      buyers.push(this.buyer)
      buyers = buyers.concat(this.coBuyers)
      return buyers
    },
    canEdit () {
      if (this.seller) {
        return this.isAdmin || this.isManager || this.isSectorManager || this.currentUserPk === this.seller.pk
      } else {
        return this.isAdmin || this.isManager || this.isSectorManager
      }
    },
    isParking () {
      if (this.lot) {
        return this.lot.nature === 'parking'
      }
    },
    choixDocuments () {
      if (this.adv && 'choix_et_tma' in this.adv && !isEmpty(this.adv.choix_et_tma)) {
        return compact(this.adv.choix_et_tma.choices.map(x => this.isAdmin || this.isSectorManager ? x.document : x.document && x.document.display ? x.document : null))
      } else return []
    },
    tmaDocuments () {
      if (this.adv && 'choix_et_tma' in this.adv && !isEmpty(this.adv.choix_et_tma)) {
        let tmaDoc = compact(Object.values(this.adv.choix_et_tma.tma).map(x => x && (this.isAdmin || this.isSectorManager) && x.document ? x : x && x.document && x.document.display ? x : null))
        let document = []
        tmaDoc.forEach(tma => {
          if (tma.document.path && tma.document.cloudinary_id) {
            if (!(this.isAdmin || this.isSectorManager) && tma.document.display === true) {
              document.push(tma.document)
            } else if (this.isAdmin || this.isSectorManager) {
              document.push(tma.document)
            }
          }
        })
        return document
      } else return []
    },
    contractDocuments () {
      if (this.contrat && 'documents' in this.contrat && !isEmpty(this.contrat.documents)) {
        let documents = []
        this.contrat.documents.forEach(documentObj => {
          if (!isEmpty(documentObj.document) && documentObj.document.path && documentObj.document.cloudinary_id) {
            if (!(this.isAdmin || this.isSectorManager) && documentObj.document.display === true) {
              documents.push(documentObj.document)
            } else if (this.isAdmin || this.isSectorManager) {
              documents.push(documentObj.document)
            }
          }
        })
        return documents
        // return compact(this.contrat.documents.map(x => this.isAdmin ? x.document : x.document && x.document.display ? x.document : null))
      } else return []
    },
    accuseDocuments () {
      if (this.contrat && 'accuse_de_reception' in this.contrat && !isEmpty(this.contrat.accuse_de_reception) && !isNil(this.contrat.accuse_de_reception.document) && this.contrat.accuse_de_reception.document.display) {
        return [this.contrat.accuse_de_reception.document]
      } else return []
    },
    loansDocuments () {
      if (this.financement && 'loans' in this.financement && !isEmpty(this.financement.loans)) {
        let document = []
        this.financement.loans.forEach(loan => {
          if (loan.document.path && loan.document.cloudinary_id) {
            if (!(this.isAdmin || this.isSectorManager) && loan.document.display === true) {
              document.push(loan.document)
            } else if (this.isAdmin || this.isSectorManager) {
              document.push(loan.document)
            }
          }
        })
        return document
      } else return []
    },
    notaireDocuments () {
      if (this.notaire && 'documents' in this.notaire && !isEmpty(this.notaire.documents)) {
        return compact(this.notaire.documents.map(x => this.isAdmin || this.isSectorManager ? x.document : x.document && x.document.display ? x.document : null))
      } else return []
    },
    advDocuments () {
      if (this.adv.documents && this.adv.documents.length) {
        return this.adv.documents.filter(x => this.isAdmin || this.isSectorManager ? x : x && x.display ? x : null)
      } else return []
    },
    advMandatDeGestion () {
      if (this.adv && 'mandat_de_gestion_file' in this.adv && !isEmpty(this.adv.mandat_de_gestion_file)) {
        if (this.adv.mandat_de_gestion_file && this.adv.mandat_de_gestion_file.display) {
          return this.adv.mandat_de_gestion_file
        } else return []
      } else return []
    },
    advSellerDocuments () {
      if (this.adv.seller_documents && this.adv.seller_documents.length) {
        return this.adv.seller_documents.filter(x => this.isAdmin || this.isSectorManager ? x : x && x.display ? x : null)
      } else return []
    },
    signatureDocuments () {
      if (this.signature && this.signature.contrat.path && this.signature.contrat.cloudinary_id) {
        let contrat = []
        contrat.push(this.adv.signature.contrat)
        return contrat
      } else return []
    },
    lotPlan () {
      if (this.lot && this.lot.plan && 'cloudinary_id' in this.lot.plan) {
        let plan = []
        plan.push(this.lot.plan)
        if (plan) {
          return plan
        } else {
          return []
        }
      } else {
        return []
      }
    },
    allDocuments () {
      return {
        lot_documents: {
          label: 'Lot',
          documents: this.lot ? [...this.lot.documents, ...this.lot.documents_flux, ...this.lotPlan] : []
        },
        program_documents: {
          label: 'Programme',
          documents: this.program ? [...this.program.documents, ...this.program.documents_flux] : []
        },
        suivi_de_vente: {
          label: 'Suivi de vente',
          documents: [...this.contractDocuments, ...this.accuseDocuments, ...this.loansDocuments, ...this.notaireDocuments, ...this.signatureDocuments]
        },
        choix_et_tma: {
          label: 'Choix et TMA',
          documents: [...this.choixDocuments, ...this.tmaDocuments]
        },
        adv_divers_documents: {
          label: 'Documents divers',
          documents: [...this.advDocuments, ...this.advSellerDocuments, ...this.advMandatDeGestion]
        }
      }
    }
  },
  methods: {
    openModalPromoteurInfo () {
      let params = {
        title: 'Promoteur contact',
        source: { ...this.adv.promoteur_contact }
      }
      this.$store.commit('setModal', {mode: 'PROMOTEUR_CONTACT', params})
    },
    goToContact (id) {
      this.$router.push({ name: 'ContactEdit', params: { id: id }, query: { check: 1 } })
    },
    previewDocument (selectedDocument) {
      let params = {
        source: selectedDocument
      }
      this.$store.commit('setModal', {mode: 'DOCUMENT_PREVIEW', params})
      // bus.$emit(EVENTS.OPEN_MODAL, {mode: 'DOCUMENT_PREVIEW', params})
    },
    updateDocument (target, data) {
      this.$set(target, 'document', data)
      this.$notify({
        type: 'is-success',
        text: 'Fichier uploadé'
      })
      this.commitAdv()
    },
    removeFile (target) {
      this.$set(target, 'document', null)
      this.commitAdv()
    },
    processFile (event, target) {
      let file = event.target.files[0]
      let files = new FormData()
      files.append('file[]', file, file.name)
      this.$api.uploadService.post(files).then(r => {
        this.$set(target, 'document', r.data[0])
        this.$notify({
          type: 'is-success',
          text: 'Fichier uploadé'
        })
        this.commitAdv()
      })
    },
    removeDocument (target) {
      Vue.delete(target, 'document')
      this.commitAdv()
    },
    commitAdv: debounce(function (adv, save = false) {
      console.log('commitAdv')
      let newAdv = Object.assign({}, this.adv, adv)
      this.$emit('commit', newAdv, save)
    }, 500),
    scrollToAdvContent () {
      let options = {
        container: '#app',
        easing: 'ease-in',
        offset: -400
      }
      VueScrollTo.scrollTo('#adv-tabulation', 150, options)
    },
    initContratDeReservationDocuments () {
      let tab = []
      if (this.coBuyers && this.coBuyers.length) {
        this.coBuyers.forEach((e, i) => {
          this.availableDocuments.push({value: `cni-${i + 2}`, name: `Carte Nationale d'Identité co-acquéreur ${i + 2}`})
        })
      }
      for (let i = 0; i < this.availableDocuments.length; i++) {
        let availableDoc = this.availableDocuments[i]
        let doc = null
        if (this.contrat && this.contrat.documents) {
          doc = find(this.contrat.documents, x => {
            return x.value === availableDoc.value
          })
        }
        if (isNil(doc)) {
          tab.push({
            check: false,
            value: availableDoc.value,
            name: availableDoc.name,
            date: null,
            status: 'not_valid',
            document: null
          })
        } else {
          tab.push(doc)
        }
      }
      return tab
    },
    initNotaireDocumentOnglet () {
      let tab = []
      this.notaire.documents.forEach(doc => {
        tab.push({
          name: doc.name,
          document: null
        })
      })
      return tab
    },
    inputChange: debounce(function () {
      this.saveAdv()
    }, 500),
    saveAdv (value) {
      if (this.wysiOpen) this.wysiOpen = false
      if (value && value.pk) Object.assign(this.adv, value)
      this.$emit('saveAdv', this.adv)
    },
    getProcedureList () {
      this.$api.advService.getProcedureList(this.advPk).then(res => {
        this.proceduresMxn = res.data
      }).catch(err => {
        console.log(err)
      })
    },
    goToLink (link) {
      this.$router.push({name: link, params: {id: this.advPk}})
    },
    backToInitialAdv () {
      this.$emit('backToInitialAdv')
    },
    backToInitialShares () {
      this.$emit('backToInitialShares')
    },
    editAdv (val) {
      this.$emit('editAdv', val)
    },
    updateCom () {
      this.$emit('updateCom')
    },
    editComment (val, source, note) {
      this.$set(source, [note], val)
      this.commitAdv()
    }
  },
  created () {
    if (this.contrat && 'documents' in this.contrat && this.contrat.documents) {
      this.contratDeReservationDocuments = this.contrat.documents
    }
    if (this.notaire && 'documents' in this.notaire && this.notaire.documents) {
      this.notaireDocumentOnglet = this.notaire.documents
    }
    if (this.currentComment && this.currentComment.length) {
      this.showCommentField = true
    }
    this.getProcedureList()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/AdvMixin.js